const colors = {
    not_deployed: "slate",
    healthy: "green",
    warning: "yellow",
    not_responding: "red",
    alert: "red",
};
// needs to be added to tailwind's safelist
// @source inline("bg-green-600");
// @source inline("bg-orange-600");
// @source inline("bg-red-600");
export function getForegroundColor(status) {
    return `bg-${colors[status]}-600`;
}
// needs to be added to tailwind's safelist
// @source inline("bg-green-950/50");
// @source inline("bg-orange-950/50");
// @source inline("bg-red-950/50");
export function getBackgroundColor(status) {
    if (status === "warning") {
        return "bg-yellow-700/50";
    }
    return `bg-${colors[status]}-950/50`;
}
// needs to be added to tailwind's safelist
// @source inline("text-green-600");
// @source inline("text-orange-600");
// @source inline("text-red-600");
export function getTextColor(status) {
    if (status === "healthy") {
        return undefined;
    }
    return `text-${colors[status]}-600`;
}
